import { ROUTES_NAMES } from './routesNames'

const {
  home,
  accessDenied,
  login,
  game,
  info,
  infoMainInfo,
  infoWorkingTime,
  settings,
  settingsLanguage,
  settingsPrint,
  settingsLastTickets,
  deposits,
  depositsVouchers,
  depositsDirectTransfer,
  page,
  cashRegister,
  calculatorTransactions,
  keyboardShortcuts,
} = ROUTES_NAMES

export const routes = [
  {
    path: '/',
    name: home,
    component: () => import('@/ui/views/HomeView.vue'),
  },
  {
    path: '/access-denied',
    name: accessDenied,
    component: () => import('@/ui/views/AccessDeniedView.vue'),
    meta: {
      layout: 'BareLayout',
    },
  },
  {
    path: '/auth',
    name: login,
    component: () => import('@/ui/views/LoginView.vue'),
    meta: {
      layout: 'LoginLayout',
    },
  },
  {
    path: '/game/:gameId',
    name: game,
    component: () => import('@/ui/views/GameView.vue'),
    props: true,
    meta: {
      layout: 'GameLayout',
    },
  },
  {
    path: '/info',
    name: info,
    component: () => import('@/ui/views/InfoView.vue'),
    meta: {
      layout: 'PageLayout',
    },
    redirect: '/info/main-info',
    children: [
      {
        path: 'main-info',
        name: infoMainInfo,
        component: () => import('@/ui/components/info/SSInfoMainInfoTab.vue'),
      },
      {
        path: 'working-time',
        name: infoWorkingTime,
        component: () => import('@/ui/components/info/SSInfoWorkingTimeTab.vue'),
      },
    ],
  },
  {
    path: '/settings',
    name: settings,
    component: () => import('@/ui/views/SettingsView.vue'),
    meta: {
      layout: 'PageLayout',
      shortcut: 'NAVIGATE_SETTINGS',
      icon: 'settings',
      titleKey: 'operation_navigation_settings',
    },
    redirect: '/settings/language',
    children: [
      {
        path: 'language',
        name: settingsLanguage,
        component: () => import('@/ui/components/settings/SSSettingsLanguage.vue'),
      },
      {
        path: 'print',
        name: settingsPrint,
        component: () => import('@/ui/components/settings/SSSettingsPrint.vue'),
      },
      {
        path: 'latest-betslips',
        name: settingsLastTickets,
        component: () => import('@/ui/components/settings/SSSettingsLastTickets.vue'),
      },
    ],
  },
  {
    path: '/deposits',
    name: deposits,
    component: () => import('@/ui/views/DepositsView.vue'),
    meta: {
      layout: 'PageLayout',
      shortcut: 'NAVIGATE_DEPOSITS',
      icon: 'bills',
      titleKey: 'operation_navigation_deposits',
    },
    redirect: '/deposits/vouchers',
    children: [
      {
        path: 'vouchers',
        name: depositsVouchers,
        component: () => import('@/ui/components/deposits/vouchers/SSDepositsVouchersTab.vue'),
      },
      {
        path: 'direct-transfer',
        name: depositsDirectTransfer,
        component: () =>
          import('@/ui/components/deposits/direct-deposits/SSDepositsDirectDepositsTab.vue'),
      },
    ],
  },
  {
    path: '/cash-register',
    name: cashRegister,
    component: () => import('@/ui/views/CashRegisterView.vue'),
    meta: {
      layout: 'PageLayout',
      shortcut: 'NAVIGATE_CASH_REGISTER',
      icon: 'cash-register',
      titleKey: 'operation_navigation_cash_register',
    },
  },
  {
    path: '/calculator/transactions',
    name: calculatorTransactions,
    component: () => import('@/ui/views/CalculatorTransactionsView.vue'),
    meta: {
      layout: 'PageLayout',
      pageHeaderClose: true,
    },
  },
  {
    path: '/keyboard-shortcuts',
    name: keyboardShortcuts,
    component: () => import('@/ui/views/KeyboardShortcutsView.vue'),
    meta: {
      layout: 'PageLayout',
      shortcut: 'NAVIGATE_KEYBOARD_SHORTCUTS',
      icon: 'keyboard',
      titleKey: 'operation_navigation_keyboard_shortcuts',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: page,
    component: () => import('@/ui/views/TestPageView.vue'),
    meta: {
      layout: 'PageLayout',
    },
  },
] as const
